import React, { FC } from 'react';
import { UitkBadgeStandard, UitkBadgeSize } from 'uitk-react-badge';
import { UitkBadgeStandardTheme } from 'uitk-react-badge/dist/types';

export interface SidebarBadgeProps {
  text: string;
  size?: UitkBadgeSize;
  theme?: UitkBadgeStandardTheme;
}

export const SidebarBadge: FC<SidebarBadgeProps> = ({ text, size, theme }) => {
  return <UitkBadgeStandard text={text} size={size} theme={theme} />;
};
